/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type AcceptOfferMutationVariables = Types.Exact<{
	input: Types.AcceptOfferRequest;
}>;

export type AcceptOfferMutation = {
	__typename?: "Mutation";
	acceptOffer:
		| {
				__typename?: "AcceptOfferInProgressResponse";
				acceptOfferInProgress: {
					__typename?: "AcceptOfferInProgress";
					type: Types.TradeType;
					fiatId: string;
					assetId: string;
					price: { __typename?: "CurrencyAmount"; value: string };
					amountFiat: { __typename?: "CurrencyAmount"; value: string };
					amountAsset: { __typename?: "CurrencyAmount"; value: string };
				};
		  }
		| {
				__typename?: "AcceptOfferSuccessResponse";
				trade: {
					__typename?: "Trade";
					tradeId: string;
					type: Types.TradeType;
					status: Types.TradeStatus;
					isFirstTrade?: boolean | null;
					fiatId: string;
					assetId: string;
					price: { __typename?: "CurrencyAmount"; value: string };
					premium?: { __typename?: "CurrencyAmount"; value: string } | null;
					executionTime: { __typename?: "DateTime"; iso8601: string; unixTimestamp: number };
					serverTime: { __typename?: "DateTime"; iso8601: string; unixTimestamp: number };
					amountFiat: { __typename?: "CurrencyAmount"; value: string };
					amountAsset: { __typename?: "CurrencyAmount"; value: string };
					fiatWallet: { __typename?: "Wallet"; id: string };
					assetWallet: { __typename?: "Wallet"; id: string };
					fiatToEuroRate: { __typename?: "CurrencyAmount"; value: string };
					fiatWalletTransaction: { __typename?: "FiatWalletTransaction"; id: string };
					taxWithheld?: {
						__typename?: "Tax";
						isTaxServiceAvailable: boolean;
						fiatId: string;
						assetId?: string | null;
						taxAmountFiat: { __typename?: "CurrencyAmount"; value: string };
						fiatAmountAfterTax?: { __typename?: "CurrencyAmount"; value: string } | null;
						taxAmountAsset?: { __typename?: "CurrencyAmount"; value: string } | null;
					} | null;
				};
		  };
};

export const AcceptOfferDocument = gql`
	mutation acceptOffer($input: AcceptOfferRequest!) {
		acceptOffer(request: $input) {
			... on AcceptOfferSuccessResponse {
				trade {
					tradeId
					price {
						value
					}
					premium {
						value
					}
					executionTime {
						iso8601
						unixTimestamp
					}
					serverTime {
						iso8601
						unixTimestamp
					}
					amountFiat {
						value
					}
					amountAsset {
						value
					}
					type
					status
					isFirstTrade
					fiatWallet {
						id
					}
					assetWallet {
						id
					}
					fiatToEuroRate {
						value
					}
					fiatWalletTransaction {
						id
					}
					fiatId
					assetId
					taxWithheld {
						taxAmountFiat {
							value
						}
						isTaxServiceAvailable
						fiatId
						assetId
						fiatAmountAfterTax {
							value
						}
						taxAmountAsset {
							value
						}
					}
				}
			}
			... on AcceptOfferInProgressResponse {
				acceptOfferInProgress {
					price {
						value
					}
					type
					amountFiat {
						value
					}
					amountAsset {
						value
					}
					fiatId
					assetId
				}
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class AcceptOfferGQLService extends Apollo.Mutation<AcceptOfferMutation, AcceptOfferMutationVariables> {
	document = AcceptOfferDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
